import configurations from "../../../../functions/configurations";

export default {
  // apiKey: "AIzaSyCDm0m7yKThLUaBvYwM2sGCb-7zsX2n79I",
  // authDomain: "beautiful-planet.firebaseapp.com",
  // databaseURL: "https://beautiful-planet.firebaseio.com",
  // projectId: "beautiful-planet",
  // storageBucket: "beautiful-planet.appspot.com",
  // messagingSenderId: "948719280954"
  apiKey: configurations.apiKey,
  authDomain: configurations.authDomain,
  databaseURL: configurations.databaseURL,
  projectId: configurations.projectId,
  storageBucket: configurations.storageBucket,
  messagingSenderId: configurations.messagingSenderId,
  appId: configurations.appId,
  measurementId: configurations.measurementId
}



// WEBPACK FOOTER //
// ./src/components/auth/browser-extension/firebaseConfig.js